import React from "react";
import styled from "styled-components";

export default function RankBadge(props) {
  return (
    <Wrapper>
      <div className={`rankTag rank_${props.label?.toLowerCase().replace(/\s+/g, '_')}`}>
        {props.label}
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .rankTag {
    display: inline-block;
    width: auto;
    min-width: 130px !important;
    padding: 2px 0px;
    color: #fff;
    font-weight: 700;
    font-size: 10px;
    text-align: center;
    text-transform: uppercase;
    border-radius: 8px;
  }

  .rank_unranked {
    background: rgba(145, 158, 171, 0.08);
    color: #212B36;
  }

  /* Basic ranks */
  .rank_promoter {
    background-color: #6c757d;
  }
  .rank_bronze {
    background-color: #cd7f32;
  }
  .rank_silver {
    background-color: #c0c0c0;
    color: #000;
  }
  .rank_gold {
    background-color: #ffd700;
    color: #000;
  }
  .rank_platinum {
    background-color: #e5e4e2;
    color: #000;
  }
  .rank_platinum_1 {
    background-color: #b4b4b4;
    color: #000;
  }
  .rank_platinum_2 {
    background-color: #a1a1a1;
    color: #000;
  }
  .rank_platinum_3 {
    background-color: #8f8f8f;
  }
  .rank_platinum_black_1 {
    background-color: #3b3b3b;
  }
  .rank_platinum_black_2 {
    background-color: #2e2e2e;
  }
  .rank_platinum_black_3 {
    background-color: #1f1f1f;
  }

  /* Replacements for old ranks */
  .rank_consultant {
    background-color: #1e719b;
  }
  .rank_team_leader {
    background-color: #658198;
  }
  .rank_senior_team_leader {
    background-color: #971e1e;
  }
  .rank_director_1 {
    background-color: #3e246e;
  }
  .rank_director_2 {
    background-color: #17317e;
  }
  .rank_director_3 {
    background-color: #664100;
  }
  .rank_elite_1 {
    background-color: #0c6b3f;
  }
  .rank_elite_2 {
    background-color: #9e5d00;
  }
  .rank_elite_3 {
    background-color: #222222;
  }

  .rank_master {
    background-color: #1f6b5e;
  }
`;
